import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

export const LegalLayout = ({ eyebrow, title, updated, children, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-ivory" data-testid={testid}>
      <Navbar />
      <section className="relative overflow-hidden bg-navy pt-40 pb-20 sm:pt-44 sm:pb-24">
        <div className="absolute inset-0 bg-navy-texture opacity-70" />
        <div className="relative z-10 mx-auto max-w-4xl px-5 sm:px-8">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="inline-flex items-center gap-3 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.35em] text-gold">
            <span className="h-px w-10 bg-gold/70" /> {eyebrow}
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }} className="mt-6 font-serif text-4xl sm:text-5xl text-white" data-testid="legal-title">
            {title}
          </motion.h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.4 }} className="mt-5 text-sm text-slate-400">
            Ultimo aggiornamento: {updated}
          </motion.p>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <article className="legal-content border border-navy/10 bg-white p-7 sm:p-12 shadow-sm" data-testid="legal-content">
            {children}
          </article>
          <Link to="/" className="mt-10 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-navy hover:text-gold-dark transition-colors" data-testid="legal-back-home">
            <ArrowLeft className="h-4 w-4" /> Torna alla home
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
};
